import Appointment from "../../modules/appointment/components/Appointment";
import { RouteParentItem } from "src/common/types";

const modules: RouteParentItem[] = [
  {
    label: "Customer",
    key: "customer",
    module: "client",
    icon: "UserOutlined",
    children: [],
  },
  // {
  //   label: "Project",
  //   key: "project",
  //   module: "project",
  //   icon: "ProjectOutlined",
  //   children: [],
  // },
  {
    label: "CRM",
    key: "crm",
    module: "crm",
    icon: "ContactsOutlined",
    children: [],
  },
  // {
  //   label: "Vehicle",
  //   key: "vehicle",
  //   module: "vehicle",
  //   icon: "CarOutlined",
  //   children: [],
  // },
  // {
  //   label: "Product Serial Registry",
  //   key: "serial",
  //   module: "serial",
  //   icon: "KeyOutlined",
  //   children: [],
  // },
  {
    label: "Purchase",
    key: "purchase",
    module: "purchase",
    icon: "ShoppingCartOutlined",
    children: [],
  },
  {
    label: "Sales",
    key: "sales",
    module: "sales",
    icon: "AccountBookOutlined",
    children: [],
  },
  // {
  //   label: "Jobs",
  //   key: "jobs",
  //   module: "jobs",
  //   icon: "FileTextOutlined",
  //   children: [],
  // },
  {
    label: "HR Records",
    key: "hr",
    module: "hr",
    icon: "UserOutlined",
    children: [],
  },
  // {
  //   label: "Service & Maintain",
  //   key: "services",
  //   module: "services",
  //   icon: "ToolOutlined",
  //   children: [],
  // },
  // {
  //   label: "Accounting",
  //   key: "accounting",
  //   module: "accounting",
  //   icon: "DollarOutlined",
  //   children: [],
  // },
  // {
  //   label: "Appointment",
  //   key: "modules/appointment",
  //   module: "appointment",
  //   icon: "SolutionOutlined",
  //   element: <Appointment />,
  //   children: [],
  // },
  // {
  //   label: "Tickets",
  //   key: "ticket",
  //   module: "ticket",
  //   icon: "SolutionOutlined",
  //   children: [],
  // },

  {
    label: "Inventory",
    key: "inventory",
    module: "inventory",
    icon: "ShopOutlined",
    children: [],
  },

  {
    label: "Requisition",
    key: "requisition",
    module: "requisition",
    icon: "SolutionOutlined",
    children: [],
  },
];

export default modules;
